// components/SocialShare.tsx
import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { SocialShareTypes } from "@components/Data/enums";
import { Group, Text, ActionIcon } from "@mantine/core";
import { useRouter } from "next/router";

interface SocialShareProps {
  url: string;
  title: string;
  otherHandler: () => Promise<void>;
}

const SocialShare: React.FC<SocialShareProps> = ({
  url,
  title,
  otherHandler,
}) => {
  const router = useRouter();
  const shareUrl = encodeURIComponent(url);
  const shareTitle = encodeURIComponent(title);

  const shareUrls = {
    [SocialShareTypes.FACEBOOK]: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    [SocialShareTypes.TWITTER]: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`,
    [SocialShareTypes.LINKEDIN]: `https://www.linkedin.com/shareArticle?url=${shareUrl}&title=${shareTitle}`,
    [SocialShareTypes.WHATSAPP]: `https://api.whatsapp.com/send?text=${shareTitle}%20%3A%0A%0A${shareUrl}`,
  };

  const icons = {
    [SocialShareTypes.FACEBOOK]: <FaFacebook />,
    [SocialShareTypes.TWITTER]: <FaTwitter />,
    [SocialShareTypes.LINKEDIN]: <FaLinkedin />,
    [SocialShareTypes.WHATSAPP]: <FaWhatsapp />,
  };

  const handleSocialButtonClick = async (type: string) => {
    await otherHandler();
    router.push(shareUrls[type]);
  };

  return (
    <Group gap="xl">
      <Group gap="xs">
        <Text fw={600}>Share</Text>
        {Object.values(SocialShareTypes).map((platform) => (
          <ActionIcon
            key={platform}
            variant="filled"
            color="yellow"
            radius="xl"
            aria-label="Settings"
            onClick={() => handleSocialButtonClick(platform)}
          >
            {icons[platform]}
          </ActionIcon>
        ))}
      </Group>
    </Group>
  );
};

export default SocialShare;
